/* This is the EMIS Skill and teaching subjects for secondary school components */
<template>
	<v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 72px;" border="1px;" width="300" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 140px; height: 50px; text-align: center; vertical-align: middle;" rowspan="2">មុខវិជ្ជា</td>
						<td class="row-header" colspan="2">បង្រៀន</td>
						<td class="row-header" colspan="2">ជំនាញដើម/ឯកទេស</td>
					</tr>
					<tr>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
					</tr>
					<!-- This is data row -->
					<tr v-for="(value, row) in e4.length -1" :key="row">
						<td class="row-title">{{e4[row]}}</td>
						<td v-for="(value, col) in data[row].dt.length" :key="col" class="row-data">
							<numberinput v-model="data[row].dt[col]" class="number"/>
						</td>
					</tr>
					<!-- This is summary row -->
					<tr>
						<td class="row-title">{{e4[15]}}</td>
						<td class="row-data">{{totalRow[0]}}</td>
						<td class="row-data">{{totalRow[1]}}</td>
						<td class="row-data">{{totalRow[2]}}</td>
						<td class="row-data">{{totalRow[3]}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
import NumberInput from '@/components/common/NumberInput.vue'
import { e4 } from '@/utils/ascf/secConfig.js'
export default {
	props: ["data", "title"],
	components: {
    'numberinput': NumberInput
  },
	data() {
    return {
			e4: e4
    }
	},
	computed: {
		// need to update the total staff in json data
		totalRow: function () {	
			let result
			let d = this.data
			let ldata = this.data.length - 1

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if (ind < ldata) { // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b)
          }
				})
				return r
			}, [])
			// update the total row array in JSON
			d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i]
			})
      return result
		}
	}
}
</script>

<style scoped>
  .number {
      width:40px;
      text-align: center;
  }
  .row-data {
    width: 40px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
  .row-title {
    width: 140px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
  .row-header {
    width: 80px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>